import { render } from "./ChangePasswordForm.vue?vue&type=template&id=753e1b54&scoped=true&ts=true"
import script from "./ChangePasswordForm.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordForm.vue?vue&type=script&lang=ts"

import "./ChangePasswordForm.vue?vue&type=style&index=0&id=753e1b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753e1b54"]])

export default __exports__